// extracted by mini-css-extract-plugin
export var antiFreezeInfo = "style-module--antiFreezeInfo--5293a";